/**
 * Faro Logger Stub
 *
 * This is a no-op implementation to replace Grafana Faro logging.
 * All methods do nothing to avoid breaking existing code that uses faroLogger.
 */

export const faroLogger = {
  /**
   * Log an info-level business event (no-op)
   */
  info: (_message: string, _context?: Record<string, any>) => {
    // No-op
  },

  /**
   * Log a warning-level business event (no-op)
   */
  warn: (_message: string, _context?: Record<string, any>) => {
    // No-op
  },

  /**
   * Log an error-level business event (no-op)
   */
  error: (_message: string, _error?: Error | Record<string, any>) => {
    // No-op
  },

  /**
   * Log a debug-level business event (no-op)
   */
  debug: (_message: string, _context?: Record<string, any>) => {
    // No-op
  },
};
